import { render, staticRenderFns } from "./ReactivateAll.vue?vue&type=template&id=bdc93c96&scoped=true"
import script from "./ReactivateAll.vue?vue&type=script&lang=js"
export * from "./ReactivateAll.vue?vue&type=script&lang=js"
import style0 from "./ReactivateAll.vue?vue&type=style&index=0&id=bdc93c96&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc93c96",
  null
  
)

export default component.exports